import type { BreadcrumbsProps } from "./types";

import { Breadcrumbs } from "@digdir/designsystemet-react";

export type { BreadcrumbsProps };

const BreadcrumbsBlock = (props: BreadcrumbsProps) => {
  const crumbs = props.items;
  if (!crumbs?.length) return null;

  return (
    <Breadcrumbs
      aria-label="Du er her:"
      className="content flex px-4 pt-2.5 pb-8 md:pt-3 md:pb-9 xl:pt-[13px] xl:pb-[41px]"
    >
      {crumbs.length > 1 && (
        <Breadcrumbs.Link
          aria-label={`Tilbake til ${crumbs[crumbs.length - 2].title}`}
          href={crumbs[crumbs.length - 2].url}
          className="text-md"
        >
          {crumbs[crumbs.length - 2].title}
        </Breadcrumbs.Link>
      )}
      <Breadcrumbs.List>
        {crumbs.map((item, index) => {
          return (
            <Breadcrumbs.Item key={item.url}>
              <Breadcrumbs.Link href={item.url} className="text-md">
                {item.title}
              </Breadcrumbs.Link>
            </Breadcrumbs.Item>
          );
        })}
      </Breadcrumbs.List>
    </Breadcrumbs>
  );
};

export default BreadcrumbsBlock;
